import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const HeroContent = () => {
  const { t } = useTranslation();

  return (
    <section className="relative pt-12 pb-12 md:pt-20 md:pb-0 overflow-hidden">
      <div className="absolute top-20 left-1/4 w-96 h-96 rounded-full bg-primary/10 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-primary/5 blur-[100px] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-8">
        <div className="max-w-4xl animate-fade-up">
          <div className="inline-flex items-center gap-2 glass rounded-full px-4 py-1.5 mb-8">
            <span className="led" />
            <span className="text-xs font-body font-medium text-primary">
              {t("hero.tag")}
            </span>
          </div>

          <h1 className="text-3xl sm:text-5xl md:text-7xl font-display font-bold tracking-display text-foreground leading-[1.05]">
            {t("hero.title1")}
            <br />
            <span className="text-primary neon-text">{t("hero.title2")}</span>
          </h1>
          <p className="mt-6 md:mt-8 text-lg md:text-xl font-body text-muted-foreground max-w-2xl leading-relaxed">
            {t("hero.subtitle")}
          </p>
          <div className="mt-8 md:mt-10 flex flex-wrap gap-4">
            <a href="#contato">
              <Button variant="hero" size="xl">
                {t("hero.cta")}
                <ArrowRight className="ml-1 h-4 w-4" />
              </Button>
            </a>
            <a href="#servicos">
              <Button variant="glass" size="xl">
                {t("hero.services")}
              </Button>
            </a>
          </div>
        </div>

        <div className="py-[8vh]" />
      </div>
    </section>
  );
};

export default HeroContent;
